export const ButtonVariant = {
    LINK: 'link',
    PRIMARY: 'primary',     // Blue
    SECONDARY: 'secondary', // Gray
    SUCCESS: 'success',     // Green
    DANGER: 'danger',       // Red
    WARNING: 'warning',     // Yellow
    INFO: 'info',           // Cyan
    LIGHT: 'light',         // White
    DARK: 'dark',           // Black
    OUTLINE_PRIMARY: 'outline-primary',     // Blue outline
    OUTLINE_SECONDARY: 'outline-secondary', // Gray outline
    OUTLINE_SUCCESS: 'outline-success',     // Green outline
    OUTLINE_DANGER: 'outline-danger',       // Red outline
    OUTLINE_WARNING: 'outline-warning',     // Yellow outline
    OUTLINE_INFO: 'outline-info',           // Cyan outline
    OUTLINE_LIGHT: 'outline-light',         // White outline
    OUTLINE_DARK: 'outline-dark',           // Black outline
}

export const Variant = {
    PRIMARY: 'primary',     // Blue
    SECONDARY: 'secondary', // Gray
    SUCCESS: 'success',     // Green
    DANGER: 'danger',       // Red
    WARNING: 'warning',     // Yellow
    INFO: 'info',           // Cyan
    LIGHT: 'light',         // White
    DARK: 'dark',           // Black
}

export const Color = {
    PRIMARY: 'primary',     // Blue
    SECONDARY: 'secondary', // Gray
    SUCCESS: 'success',     // Green
    DANGER: 'danger',       // Red
    WARNING: 'warning',     // Yellow
    INFO: 'info',           // Cyan
    LIGHT: 'light',         // White
    DARK: 'dark',           // Black
    WHITE: 'white',
    MUETED: 'muted',
}

export const ButtonType = {
    SUBMIT: 'submit',
    RESET: 'reset',
    BUTTON: 'button',
}

export const FormCheckType = {
    CHECKBOX: 'checkbox',
    RADIO: 'radio',
    SWITCH: 'switch',
}

export const FormControlType = {
    CHECKBOX: 'checkbox',
    FILE: 'file',
    TEXT: 'text',
    EMAIL: 'email',
    PASSWORD: 'password',
    SUBMIT: 'submit',
}

export const FeedbackType = {
    VALID: 'valid',
    INVALID: 'invalid',
}